import React from "react";

const PAIN = [
    "Books in one tool.",
    "Invoices in another.",
    "Payments tracked over chat and email.",
    "GST prepared close to the deadline.",
    "Bank reconciliation done in spreadsheets.",
];

const FIX = [
    "Books, invoices and payments in one workspace.",
    "A single ledger shared with your team and CA.",
    "GST returns prepared from the same data.",
    "Bank statements imported and matched with AI-assisted rules.",
    "Multi-currency and multi-entity supported out of the box.",
];

export default function ProblemFix() {
    return (
        <section className="vy-section" data-testid="landing-problemfix">
            <div className="vy-container">
                <div className="vy-reveal" style={{ textAlign: "center", marginBottom: 48 }}>
                    <div className="vy-kicker">&gt; the.problem  //  the.fix</div>
                    <h2 className="vy-serif vy-h-section" style={{ fontSize: "2.8rem", marginTop: 10, color: "var(--vy-navy)" }}>
                        <span style={{ opacity: 0.7 }}>Books, invoices, GST and banking</span>{" "}
                        <span className="vy-serif-i">— in one system.</span>
                    </h2>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 40, alignItems: "stretch" }} className="vy-grid-2">
                    {/* Pain column */}
                    <div className="vy-reveal" data-vy-delay="1" data-testid="problemfix-pain">
                        <div className="vy-kicker" style={{ color: "var(--vy-danger)" }}>× BEFORE VYAAHAR</div>
                        <div style={{ marginTop: 16, borderLeft: "2px solid rgba(160,44,44,0.5)", paddingLeft: 22 }}>
                            {PAIN.map((line, i) => (
                                <div key={i} className="vy-serif" style={{
                                    fontSize: 22, lineHeight: 1.4, color: "var(--vy-ink)", marginBottom: 10,
                                    opacity: 1 - i * 0.08,
                                }}>
                                    {line}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Divider */}
                    <div aria-hidden style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div style={{ width: 1, background: "var(--vy-hair)", height: "100%", minHeight: 160 }} />
                    </div>

                    {/* Fix column */}
                    <div className="vy-reveal" data-vy-delay="2" data-testid="problemfix-fix">
                        <div className="vy-kicker" style={{ color: "var(--vy-positive)" }}>✓ WITH VYAAHAR</div>
                        <div style={{ marginTop: 16, borderLeft: "2px solid var(--vy-gold)", paddingLeft: 22 }}>
                            {FIX.map((line, i) => (
                                <div key={i} className="vy-serif" style={{
                                    fontSize: 22, lineHeight: 1.4, color: "var(--vy-navy)", marginBottom: 10, fontWeight: 500,
                                }}>
                                    {line}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
